/* istanbul ignore file */
import React from 'react';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';

import { RibbonsPage } from 'src/components/templates/RibbonsPage/RibbonsPage';
import { SKIP_CONTENT_TARGET_ID } from 'src/constants/elementIds';
import { getPageContent } from 'src/content/getPageContent';
import { transformModularContentToUISections } from 'src/content/transformModularContentToUISections';
import { transformSeo } from 'src/content/transformSeo';
import type { ContentPageResultProps, PageConfiguration } from 'src/types/PageProps';
import { getContentPageErrorResult } from 'src/utils/getContentPageErrorResult';
import { getPageMetadata } from 'src/utils/getPageMetadata';

const pageConfig: PageConfiguration = {
  env: process.env.NODE_ENV,
  contentType: 'about',
  pageType: 'about',
  trackingCategory: 'About',
};

export const getServerSideProps: GetServerSideProps<ContentPageResultProps> = async (context) => {
  const pageMetadata = getPageMetadata(context);

  try {
    const { pageContent, siteChromeContent } = await getPageContent(pageConfig, pageMetadata);

    return {
      props: {
        pageConfig,
        pageMetadata,
        pageContent: {
          sections: await transformModularContentToUISections(
            pageContent.modular_content,
            pageConfig,
            pageMetadata,
          ),
          title: pageContent.title,
          seo: transformSeo(pageContent.seo, pageConfig, pageMetadata.pathname),
        },
        pageEventCategory: pageConfig.trackingCategory,
        siteChromeContent,
      },
    };
  } catch (error) {
    return getContentPageErrorResult(context.res, error);
  }
};

const CampaignPage = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <div id={SKIP_CONTENT_TARGET_ID}>
    <RibbonsPage {...props} />
  </div>
);

export default CampaignPage;
